import {
  AttributeOptionSet,
  GlobalGroupProductKey,
  GlobalGroupProducts,
  GroupAttributeCodeOptionDependency,
  GroupAttributeCodeSetSource,
  GroupParentAttributeOptionSet,
  GroupParentAttributeOptionSetValue,
  OptionDependency,
  OptionDependencyKey,
  ParentAttributeOptionSet,
  SelectedOptionStringify,
} from "@/components/configurator/global-option/types";

export default class Deserialize {
  static groupAttributeCodeSetSource(
    data: any,
  ): GroupAttributeCodeSetSource | undefined {
    if (!data) return undefined;
    return new Map(JSON.parse(data) as GroupAttributeCodeSetSource);
  }
  static readonly groupParentAttributeOptionSet = (
    data: string,
  ): GroupParentAttributeOptionSet | undefined => {
    if (!data) return undefined;
    const parsedData: SelectedOptionStringify[] = JSON.parse(data);

    const groupParentAttributeOptionSet: GroupParentAttributeOptionSet =
      new Map() as GroupParentAttributeOptionSet;

    parsedData.forEach((item) => {
      const { groupKey, groupInfo, parents } = item;
      const GroupParentAttributeOptionSetValue: GroupParentAttributeOptionSetValue =
        {
          groupId: groupInfo.groupId,
          groupName: groupInfo.groupName,
          isProduct: groupInfo.isProduct,
          isCollapsed: groupInfo.isCollapsed,
          isGrayOut: groupInfo.isGrayOut,
          isDisabled: groupInfo.isDisabled,
          isVisible: groupInfo.isVisible,
          isTooltipVisible: groupInfo.isTooltipVisible,
          isChildDependentOnMainBody: groupInfo.isChildDependentOnMainBody,
          isMiscellaneous: groupInfo.isMiscellaneous,
          tooltipData: groupInfo.tooltipData,
          selectionType: groupInfo.selectionType,
          parents: new Map(),
        };

      const parentMap = new Map<string, ParentAttributeOptionSet>();

      parents.forEach((parent) => {
        parentMap.set(parent.parentKey, parent.value);
      });

      GroupParentAttributeOptionSetValue.parents = parentMap;
      groupParentAttributeOptionSet.set(
        groupKey,
        GroupParentAttributeOptionSetValue,
      );
    });
    return groupParentAttributeOptionSet;
  };

  static readonly globalGroupProducts = (
    data: string,
  ): GlobalGroupProducts | undefined => {
    if (!data) return undefined;
    return new Map(JSON.parse(data) as GlobalGroupProducts);
  };

  static readonly groupAttributeCodeOptionDependency = (
    data: string,
  ): GroupAttributeCodeOptionDependency | undefined => {
    if (!data) return undefined;
    const parsed = JSON.parse(data);
    const dependency = new Map<
      GlobalGroupProductKey,
      Map<string, OptionDependency>
    >();

    for (const groupKeyString in parsed) {
      const groupKey: GlobalGroupProductKey = JSON.parse(groupKeyString);
      const attributeMap = new Map<string, OptionDependency>();

      for (const attributeCode in parsed[groupKeyString]) {
        const optionDependency = new Map<OptionDependencyKey, Set<number>>();

        for (const optionKeyString in parsed[groupKeyString][attributeCode]) {
          const optionKey: OptionDependencyKey = JSON.parse(optionKeyString);
          const dependentKeys: Set<number> = new Set(
            parsed[groupKeyString][attributeCode][optionKeyString],
          );
          optionDependency.set(optionKey, dependentKeys);
        }

        attributeMap.set(attributeCode, optionDependency);
      }

      dependency.set(groupKey, attributeMap);
    }

    return dependency;
  };
}
